import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-48fd2cd8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "basic__table cms-card-block"
};
import { useI18n } from 'vue-i18n';
import dayjs from 'dayjs';
import { onMounted } from 'vue';
import { getLogListApi } from '@/api/traceDebug';
import { getSysDictListApi, getModelsApi, getactiveUserApi, getNationListApi } from '@/api/live';
import { ElMessage } from 'element-plus';
import Charts from '../components/charts.vue';
import { usePlatformsByUser } from '@/utils/cacheData';
import { useCommon } from '@/store/useCommon';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const paltformList = ref([{
      value: 'all',
      label: t('全部')
    }]);
    const modelList = ref([{
      value: 'all',
      label: t('全部')
    }]);
    const isVnoAccount = useCommon().userData.roles.some(item => /VNO/ig.test(item)) || useCommon().userData.roles.includes('CUSTOMER_SN'); //区分是否为vno运营商账号

    const cpspId = isVnoAccount ? useCommon().userData.cid[0] : Number(sessionStorage.getItem('currentCid'));
    const nationObj = ref([{
      label: t('全部'),
      value: 'all'
    }]);
    const charts = ref();
    const loading = ref(false);
    const options = ref({
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: [t('活跃用户'), t('在线用户')]
      },
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: {
        type: 'value'
      },
      series: [{
        name: t('活跃用户'),
        type: 'line',
        data: []
      }, {
        name: t('在线用户'),
        type: 'line',
        data: []
      }]
    });
    onMounted(() => {
      loading.value = true;
      getPlatform();
      getNationList();
      getModuleObj();
      handleSearch(searchConfig.formData);
      loading.value = false;
    });
    const timeOption = ref([{
      value: 0,
      label: t('最近1周')
    }, {
      value: 1,
      label: t('最近2周')
    }, {
      value: 2,
      label: t('最近1个月')
    }]);
    const loginOPtion = [{
      value: 0,
      label: 'SN'
    }, {
      value: 1,
      label: t('账号')
    }, {
      value: 2,
      label: t('激活码')
    }];
    const clientTypeObj = ref([{
      value: 'all',
      label: t('全部')
    }]);
    const timeObj = ref({
      //最近一周
      0: {
        start: dayjs().startOf('day').subtract(6, 'day').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      },
      //最近两周
      1: {
        start: dayjs().startOf('day').subtract(13, 'day').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      },
      //最近一个月
      2: {
        //当前日+1是否等于1，判断是否当月最后一天，是则start从1开始，否则按30天一个月计算
        start: dayjs().add(1, 'day').date() === 1 ? dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss') : dayjs().startOf('day').subtract(29, 'day').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
    });
    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '开始时间',
        prop: 'startTime',
        widgetType: 'date'
      }, {
        label: '结束时间',
        prop: 'endTime',
        widgetType: 'date'
      }, {
        label: '',
        prop: 'timeType',
        widgetType: 'Select',
        list: timeOption,
        change: val => {
          // 变更时间
          searchConfig.formData.startTime = timeObj.value[val].start;
          searchConfig.formData.endTime = timeObj.value[val].end;
        }
      }, {
        label: '设备类型',
        prop: 'type',
        widgetType: 'Select',
        list: clientTypeObj,
        valueKey: 'label'
      }, {
        label: '平台',
        prop: 'platform',
        widgetType: 'Select',
        list: paltformList,
        filterable: true,
        change: val => {
          if (val === 'all') return false;
          searchConfig.formData.model = '';
          let params = {
            pids: val
          };
          getModelList(params);
        }
      }, {
        label: '机型',
        prop: 'model',
        widgetType: 'Select',
        list: modelList,
        filterable: true
      }, {
        label: '国家',
        prop: 'nation',
        widgetType: 'Select',
        list: nationObj,
        valueKey: 'label'
      }],
      formData: {
        startTime: dayjs().startOf('day').subtract(6, 'day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        timeType: 0,
        model: 'all',
        type: t('全部'),
        platform: 'all',
        nation: t('全部')
      }
    });

    const handleSearch = async val => {
      console.log('search', val);
      if (val.type === '') return ElMessage({
        type: 'warning',
        message: t('请选择设备类型')
      });
      if (val.platform === '') return ElMessage({
        type: 'warning',
        message: t('请选择平台')
      });
      if (val.model === '') return ElMessage({
        type: 'warning',
        message: t('请选择机型')
      });
      loading.value = true;
      let ids = val.model.split('-');
      let params = {
        startTime: val.startTime.split(' ')[0],
        endTime: val.endTime.split(' ')[0],
        type: val.type,
        mid: ids[1],
        pid: val.platform === 'all' ? undefined : Number(val.platform),
        nation: val.nation
      }; //type选全部时，不传数据给后端

      if (val.type === t('全部')) delete params.type;
      if (val.nation === t('全部')) delete params.nation;

      if (val.model === 'all') {
        delete params.mid;
      }

      const {
        code,
        data
      } = await getactiveUserApi(params);

      if (code == 0) {
        options.value.series[0].data = data.series[0].data;
        options.value.series[1].data = data.series[1].data;
        options.value.xAxis.data = data.xaxis.data;
        charts.value.drawChart(); //触发重新渲染

        data.category && data.category.length === 0 && ElMessage({
          type: 'warning',
          message: t('未查询到数据')
        });
      }

      loading.value = false;
    }; //重置


    const handleReset = () => {
      searchConfig.formData = {
        startTime: dayjs().startOf('day').subtract(6, 'day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        timeType: 0,
        model: 'all',
        type: t('全部'),
        platform: 'all',
        nation: t('全部')
      };
      modelList.value = [{
        value: 'all',
        label: t('全部')
      }];
      options.value.series[0].data = [];
      options.value.xAxis.data = [];
      handleSearch(searchConfig.formData);
    }; // 获取日志列表


    const getLogList = async params => {
      const {
        data,
        code
      } = await getLogListApi(params);

      if (code == 0) {
        if (data.records.length === 0) return ElMessage({
          type: 'warning',
          message: t('未查询到数据')
        });
      }
    };

    const getModuleObj = async () => {
      const {
        code,
        data
      } = await getSysDictListApi('client_type');

      if (code == 0) {
        clientTypeObj.value = [...clientTypeObj.value, ...data];
      }
    }; // 获取平台数据


    const getPlatform = async () => {
      const platform = await usePlatformsByUser();
      let newPlatform = platform.map(item => {
        return {
          label: item.prefixName,
          value: String(item.pid)
        };
      });
      paltformList.value = [...paltformList.value, ...newPlatform];
    }; // 获取model列表


    const getModelList = async params => {
      const {
        data,
        code
      } = await getModelsApi(params);

      if (code == 0 && data.length > 0) {
        let newModelList = data.map(item => {
          return { ...item,
            label: item.modelName,
            value: `${item.cid}-${item.mid}-${item.pid}` //model对应的3id，用来请求图形数据

          };
        });
        modelList.value = [{
          label: t('全部'),
          value: 'all'
        }, ...newModelList];
      } else {
        modelList.value = [{
          label: t('全部'),
          value: 'all'
        }];
      }
    };

    const getNationList = async () => {
      const {
        code,
        data
      } = await getNationListApi();

      if (code == 0) {
        nationObj.value = [...nationObj.value, ...data];
      }
    };

    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        size: searchConfig.size,
        onSearch: handleSearch,
        onReset: handleReset,
        gutter: 50
      }, null, 8, ["form-list", "form-data", "size"])])), [[_directive_loading, loading.value]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(Charts, {
        option: options.value,
        ref_key: "charts",
        ref: charts
      }, null, 8, ["option"])])])), [[_directive_loading, loading.value]])], 64);
    };
  }

});